import type { Result } from 'true-myth';

export const unwrapResult = async <Value, Failure extends Error>(
    pending: Promise<Result<Value, Failure>>,
): Promise<Value> => {
    const result = await pending;

    if (result.isErr) {
        throw result.error;
    }

    return result.value;
};
